/* eslint-disable import/prefer-default-export */
import axios from 'axios'
import Cookies from 'js-cookie'
import {apiURLs, getWithCredentials, getIPlanetProCookieName} from './Utility'

import { getCsrfToken as getStoredCsrfToken } from './csrfToken'

const csrfCookieNames = ['XSRF-TOKEN', 'CSRF-TOKEN', 'X-CSRF-TOKEN']

const getCsrfToken = () => {
  const storedToken = getStoredCsrfToken()
  if(storedToken) {
    return storedToken
  }
  for(let i = 0; i < csrfCookieNames.length; i += 1) {
    const token = Cookies.get(csrfCookieNames[i])
    if(token) {
      return token
    }
  }
  return null
}

const withCsrfHeader = (request = {}) => {
  const method = (request.method || 'GET').toUpperCase()
  if(!['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    return request
  }

  const csrfToken = getCsrfToken()
  if(!csrfToken) {
    return request
  }

  return {
    ...request,
    headers: {
      ...(request.headers || {}),
      'X-CSRF-Token': csrfToken,
      'X-XSRF-TOKEN': csrfToken
    }
  }
}

/**
 * Custom axios instance for forgeRock
 * @param {string} companyId
 * @param {string} userId
 * @param {string} password
 */
export const authenticateAxiosInstance = axios.create({
  baseURL: apiURLs.authenticateUrl,
  headers: {
    'Content-Type': 'application/json'
  },
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  withCredentials: getWithCredentials()
});

authenticateAxiosInstance.interceptors.request.use(withCsrfHeader)

export default {
  authenticate: (companyId, userId, password) =>
    authenticateAxiosInstance({
      url: '/authenticate',
      method: 'POST',
      data: {
        companyId, userId, password
      }
    }),
  login: () =>
    authenticateAxiosInstance({
      url: '/login',
      method: 'GET',
    })
  ,
  trakkerHandoff: () =>
    authenticateAxiosInstance({
      url: '/trakker/handoff',
      method: 'GET',
    })
  ,
  setPDPCookie: iPlanetDirectoryProCookie => {
    authenticateAxiosInstance.defaults.headers[getIPlanetProCookieName()] = iPlanetDirectoryProCookie
  },
  logout: () =>
    authenticateAxiosInstance({
      url: '/logout',
      method: 'POST'
    })
  ,
  setRequestInterceptor: (interceptor) => {
    authenticateAxiosInstance.interceptors.request.use(interceptor)
  },
  setResponseInterceptor: (interceptor) => {
    authenticateAxiosInstance.interceptors.response.use(interceptor)
  },
};
